import Menu from './component';

export default Menu;
